export const REQUEST_ACTIVATION = 'REQUEST_ACTIVATION';
export const RECEIVE_ACTIVATION = 'RECEIVE_ACTIVATION';
export const REQUEST_ACTIVATION_STATUS_CHANGE =
  'REQUEST_ACTIVATION_STATUS_CHANGE';
export const RECEIVE_ACTIVATION_STATUS_CHANGE =
  'RECEIVE_ACTIVATION_STATUS_CHANGE';
export const REQUEST_ACTIVATION_STATUS = 'REQUEST_ACTIVATION_STATUS';
export const RECEIVE_ACTIVATION_STATUS = 'RECEIVE_ACTIVATION_STATUS';
export const OPEN_SETTINGS_DRAWER = 'OPEN_SETTINGS_DRAWER';
export const CLOSE_SETTINGS_DRAWER = 'CLOSE_SETTINGS_DRAWER';
export const UPDATE_TAG_SETTINGS = 'UPDATE_TAG_SETTINGS';
export const REQUEST_LOCATION_AND_LANGUAGE_CHANGE =
  'REQUEST_LOCATION_AND_LANGUAGE_CHANGE';
export const RECEIVE_LOCATION_AND_LANGUAGE_CHANGE =
  'RECEIVE_LOCATION_AND_LANGUAGE_CHANGE';
export const UPDATE_INPUT_ERRORS = 'UPDATE_INPUT_ERRORS';
export const SHOW_TOAST = 'SHOW_TOAST';
export const DISMISS_TOAST = 'DISMISS_TOAST';

export const SETUP_PERMISSION = {
  OBJECT: 'Administration',
  OPERATION: 'Access'
};

// hard-coded list of Google Translate Basic supported languages
export const LANGUAGE_CODES = [
  'af',
  'sq',
  'am',
  'ar',
  'hy',
  'az',
  'eu',
  'be',
  'bn',
  'bs',
  'bg',
  'ca',
  'ceb',
  'zh-CN',
  'zh-TW',
  'co',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'eo',
  'et',
  'fi',
  'fr',
  'fy',
  'gl',
  'ka',
  'de',
  'el',
  'gu',
  'ht',
  'ha',
  'haw',
  'he',
  'hi',
  'hmn',
  'hu',
  'is',
  'ig',
  'id',
  'ga',
  'it',
  'ja',
  'jv',
  'kn',
  'kk',
  'km',
  'rw',
  'ko',
  'ku',
  'ky',
  'lo',
  'la',
  'lv',
  'lt',
  'lb',
  'mk',
  'mg',
  'ms',
  'ml',
  'mt',
  'mi',
  'mr',
  'mn',
  'my',
  'ne',
  'no',
  'ny',
  'or',
  'ps',
  'fa',
  'pl',
  'pt',
  'pa',
  'ro',
  'ru',
  'sm',
  'gd',
  'sr',
  'st',
  'sn',
  'sd',
  'si',
  'sk',
  'sl',
  'so',
  'es',
  'su',
  'sw',
  'sv',
  'tl',
  'tg',
  'ta',
  'tt',
  'te',
  'th',
  'tr',
  'tk',
  'uk',
  'ur',
  'ug',
  'uz',
  'vi',
  'cy',
  'xh',
  'yi',
  'yo',
  'zu'
];
